import React, { useEffect, useState } from 'react'
import axios from "../../config/axios";
import { useNavigate } from "react-router-dom";

const StripeOrderPaymentReturn = () => {
  const [status, setStatus] = useState(null);
  const [orderId, setOrderId] = useState(null);
  const navigate = useNavigate();

    useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const sessionId = urlParams.get('session_id');


    checkPaymentAndPlaceOrder(sessionId)
      
    // fetch(`/session-status?session_id=${sessionId}`)
    //   .then((res) => res.json())
    //   .then((data) => {
    //     setStatus(data.status);
    //     setCustomerEmail(data.customer_email);
    //   });
  }, []);

    const checkPaymentAndPlaceOrder = async (sessionId) =>{
    const orderRes = await axios.post("/cart/place-order", {
      stripeSessionId: sessionId
    });

     if (orderRes?.data?.orderId) {
      navigate(`/payment-received/order/success/${orderRes.data.orderId}`);
     }else{
      navigate(`/payment-received/order/failed/null`);
     }

  }
  return (
    <div>StripeOrderPaymentReturn</div>
  )
}

export default StripeOrderPaymentReturn